// client/src/types/support/logins.ts
//
// Types and query keys for the Support → Logins shared credential vault.
// Passwords are never present on the client list shape — the server returns a
// `hasPassword` flag and decrypts a single password on demand via reveal.

export const LOGIN_CATEGORIES = [
  'dealer_site',
  'vendor',
  'permitting_agency',
  'utility',
  'other',
] as const;

export type LoginCategory = (typeof LOGIN_CATEGORIES)[number];

export const LOGIN_CATEGORY_LABELS: Record<LoginCategory, string> = {
  dealer_site: 'Dealer Site',
  vendor: 'Vendor',
  permitting_agency: 'Permitting Agency',
  utility: 'Utility',
  other: 'Other',
};

/** A login as returned by `support_listLogins` — no password material. */
export interface SupportLogin {
  loginId: string;
  organizationId: string;
  label: string;
  category: LoginCategory;
  url: string;
  username: string;
  notes: string;
  hasPassword: boolean;
  createdAt: number | null;
  createdByName: string;
  updatedAt: number | null;
  updatedByName: string;
}

/** Payload for creating a login. `password` is sent once and encrypted server-side. */
export interface CreateLoginPayload {
  label: string;
  category: LoginCategory;
  url?: string;
  username?: string;
  password?: string;
  notes?: string;
}

/** Mutable fields for an update. Omit `password` to keep the existing one. */
export interface UpdateLoginFields {
  label?: string;
  category?: LoginCategory;
  url?: string;
  username?: string;
  password?: string;
  notes?: string;
}

export const loginsKeys = {
  all: ['supportLogins'] as const,
  lists: () => [...loginsKeys.all, 'list'] as const,
  list: (orgId: string) => [...loginsKeys.lists(), orgId] as const,
};
